import { getElement, getElements, toggleClass, removeClass } from '../helpers/functions';

// Opens the Usercentrics privacy settings ("second layer").
// v3 (Web CMP) exposes window['__ucCmp']; v2 exposes window.UC_UI.
const openCookieSettings = () => {
  // eslint-disable-next-line no-underscore-dangle
  const ucCmp = window.__ucCmp;
  if (ucCmp?.showSecondLayer) {
    ucCmp.showSecondLayer();
  } else if (window.UC_UI?.showSecondLayer) {
    window.UC_UI.showSecondLayer();
  }
};

// The cookie-settings link is hidden by default (d-none in the template). It is
// only revealed and wired up when the Usercentrics CMP is actually present and
// initialized — so if UC is not included or fails to load, the link stays hidden.
const initCookieSettings = () => {
  const $link = getElement('.js-cookie-settings');
  if (!$link) return;
  const enable = () => {
    removeClass($link, 'd-none');
    $link.addEventListener('click', e => {
      e.preventDefault();
      openCookieSettings();
    });
  };

  // eslint-disable-next-line no-underscore-dangle
  if (window.UC_UI?.isInitialized?.() || window.__ucCmp) {
    // CMP already ready (script ran after init).
    enable();
  } else {
    // Wait for Usercentrics to finish loading; never fires if UC is absent.
    window.addEventListener('UC_UI_INITIALIZED', enable, {
      once: true
    });
  }
};
export default () => {
  const $footerAccordions = getElements('.footer-accordion');
  $footerAccordions.forEach($accordion => {
    const $label = getElement('.footer-accordion--button', $accordion);
    const $frame = getElement('.footer-accordion--body', $accordion);
    if (!$label || !$frame) return;
    $label.addEventListener('click', () => {
      toggleClass($frame, '__open');
    });
  });
  initCookieSettings();
};